module.exports = __webpack_public_path__ + "img/video-player/down@3x-eb787bf4efb9c58f603268fa3a816d95.png";